
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class TestResultDialog extends SiteEntityDialog<TestResultRow, any> {
        protected getFormKey() { return TestResultForm.formKey; }
        protected getIdProperty() { return TestResultRow.idProperty; }
        protected getLocalTextPrefix() { return TestResultRow.localTextPrefix; }
        protected getNameProperty() { return TestResultRow.nameProperty; }
        protected getService() { return TestResultService.baseUrl; }

        protected form = new TestResultForm(this.idPrefix);
        private popupMenuEl: JQuery;
        private exceptionLinks: Q.Grouping<Exceptions.ExceptionLinkRow>;
        private exceptionRowIdsByIndex: number[];

        constructor() {
            super();

            this.form.ResultTable.element.on('click.' + this.uniqueName, '.exception-links', (e) => {

                if (!this.popupMenuEl) {
                    this.popupMenuEl = $(`<ul style="width: 300px"></ul>`);
                    this.popupMenuEl.on('click', 'a', (e) => {
                        Exceptions.handleExceptionLinkClick(e);
                    });
                }

                var itemIndex = $(e.currentTarget).attr('data-index');
                if (!this.exceptionLinks || itemIndex == null)
                    return;

                var exceptionRowId = this.exceptionRowIdsByIndex[itemIndex];
                if (exceptionRowId == null)
                    return;

                var links = this.exceptionLinks[exceptionRowId];
                if (!links || !links.length)
                    return;

                this.popupMenuEl.html('');

                Exceptions.renderExceptionLinks(this.popupMenuEl, links);
                popupMenuShow(this.popupMenuEl, e);
            });

            this.form.ResultTable.editColumns = columns => {

                columns.splice(0, 0, {
                    id: '__links',
                    field: '__links',
                    width: 30,
                    maxWidth: 30,
                    minWidth: 30,
                    formatter: Serenity.SlickHelper.convertToFormatter(ctx => {

                        if (!this.exceptionLinks || ctx.item == null)
                            return "";

                        var exceptionRowId = this.exceptionRowIdsByIndex[ctx.item.__id - 1];
                        if (exceptionRowId == null)
                            return "";

                        var links = this.exceptionLinks[exceptionRowId];
                        if (!links || !links.length)
                            return "";

                        return `<a class="inline-action exception-links" title="links" 
data-index="${ctx.item.__id - 1}"><i class="fa fa-bars"></i></a>`;
                    }),
                    headerFilterType: Serenity.HeaderFilterType.disabled,
                    sortable: false
                });
                return columns;
            }


        }

        destroy() {
            this.form?.ResultTable?.element.off('.' + this.uniqueName);
            super.destroy();
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.exceptionLinks = null;
            this.form.ResultTable.xmlData = this.form.ResultData.value;

            if (this.entity.FailCount) {
                Exceptions.ExceptionLinkService.List({
                    ColumnSelection: Serenity.ColumnSelection.KeyOnly,
                    IncludeColumns: [
                        Exceptions.ExceptionLinkRow.Fields.LinkToSchema,
                        Exceptions.ExceptionLinkRow.Fields.LinkToTable,
                        Exceptions.ExceptionLinkRow.Fields.LinkToEntityKey,
                        Exceptions.ExceptionLinkRow.Fields.LinkToUrl,
                        Exceptions.ExceptionLinkRow.Fields.LinkToText,
                        Exceptions.ExceptionLinkRow.Fields.ExceptionRowId,
                        Exceptions.ExceptionLinkRow.Fields.ExceptionContextIndex,
                    ],
                    EqualityFilter: <Exceptions.ExceptionLinkRow>{
                        ExceptionSource: 'DataQualityTest',
                        ExceptionContext: this.entityId ?? -1
                    },
                    Sort: [
                        Exceptions.ExceptionLinkRow.Fields.ExceptionLinkId
                    ]
                }, response => {
                    var exceptionLinks = response.Entities || [];
                    this.exceptionLinks = Q.toGrouping(exceptionLinks, x => x.ExceptionRowId);
                    this.exceptionRowIdsByIndex = Object.keys(this.exceptionLinks).map(x => Q.toId(x));
                    this.exceptionRowIdsByIndex.sort();
                    for (var link of exceptionLinks) {
                        if (link.ExceptionContextIndex != null)
                            this.exceptionRowIdsByIndex[link.ExceptionContextIndex] = link.ExceptionRowId;
                    }

                    this.form.ResultTable.xmlData = this.form.ResultData.value;
                });
            }
        }
    }

    
}